import { useRadio } from '@react-aria/radio';
import type { RadioProps } from '@react-types/radio';
import classNames from 'clsx';
import React, { useContext, useRef } from 'react';

import { RadioContext } from '../RadioGroup/RadioGroup';

import styles from './Radio.scss';

interface Props extends RadioProps {
  className?: string;
}

export const Radio: React.FC<Props> = (props) => {
  const state = useContext(RadioContext);
  const ref = useRef(null);
  const { inputProps } = useRadio(props, state, ref);

  return (
    <label className={classNames(styles.radio, props.className)}>
      <input className={styles.radioButton} {...inputProps} ref={ref} />
      {props.children}
    </label>
  );
};
